import { Link } from "react-router-dom";

export const AffiliateBadge = ({ className = "" }: { className?: string }) => (
  <Link
    to="/affiliate-disclosure"
    onClick={(e) => e.stopPropagation()}
    title="We may earn a commission if you sign up through this link"
    className={`text-[9px] font-mono px-1.5 py-0.5 rounded border border-primary/30 bg-primary/5 text-primary/80 hover:bg-primary/10 transition-colors uppercase tracking-wider ${className}`}
  >
    aff
  </Link>
);
